<template>
  <v-row>
    <v-col cols="12">
      <v-card
        width="100%"
        elevation="0"
        class="rounded-0"
        color="grey lighten-5"
      >
        <v-card-title>
          <h3>{{ $t("alerts.titleSelect") }}</h3>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-autocomplete
            dense
            v-model="model"
            :items="items"
            :loading="isLoading"
            filled
            :search-input.sync="search"
            hide-no-data
            @change="selectCountry"
            hide-selected
            item-text="search_nom"
            no-filter
            :placeholder="$t('alerts.searchCity')"
            return-object
          ></v-autocomplete>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6">
      <v-row>
        <v-col cols="12">
          <v-card
            elevation="0"
            color="grey lighten-5"
            :disabled="markerLatLon.length == 0"
            class="alert-form-container bg-white rounded-lg p-5"
          >
            <v-card-title>
              <h3 v-if="cityName && !edit">
                {{ $t("alerts.titleNew") }} {{ cityName }}
              </h3>
              <h3 v-else-if="edit">
                {{ $t("alerts.titleEdit") }} {{ cityName }}
              </h3>
              <h3 v-else>{{ $t("alerts.titleSelect") }}</h3>
            </v-card-title>

            <v-card-text>
              <v-row align="center" justify="center">
                <v-col cols="12">
                  <v-select
                    dense
                    :hide-details="true"
                    filled
                    v-model="choice"
                    :items="alertTypeFiltered"
                    @change="addAlerte"
                  />
                </v-col>
              </v-row>

              <br />

              <v-list class="grey lighten-5">
                <v-list-item
                  v-for="condition in conditions"
                  :key="condition.id"
                >
                  <v-row align="center" justify="center">
                    <v-col cols="11">
                      <!-- Wind -->
                      <template v-if="condition.key === 'wind'">
                        <v-select
                          dense
                          filled
                          suffix="km/h"
                          :label="alertType[1].text"
                          v-model="condition.number"
                          :items="[
                            15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75,
                            80, 85, 90, 95, 100,
                          ]"
                        ></v-select>
                      </template>

                      <!-- Temp mini-->
                      <template v-if="condition.key === 'temp-min'">
                        <v-text-field
                          filled
                          dense
                          suffix="°C"
                          :label="alertType[2].text"
                          type="number"
                          :min="-40"
                          :step="1"
                          :max="50"
                          v-model="condition.number"
                        ></v-text-field>
                      </template>

                      <!-- Temp max-->
                      <template v-if="condition.key === 'temp-max'">
                        <v-text-field
                          filled
                          dense
                          suffix="°C"
                          :label="alertType[3].text"
                          type="number"
                          :min="15"
                          :step="1"
                          :max="40"
                          v-model="condition.number"
                        ></v-text-field>
                      </template>

                      <!-- Rain max-->
                      <template v-if="condition.key === 'rain-max'">
                        <v-text-field
                          filled
                          dense
                          suffix="mm"
                          :label="alertType[4].text"
                          type="number"
                          :min="0"
                          :step="5"
                          :max="100"
                          v-model="condition.number"
                        ></v-text-field>
                      </template>

                      <!-- Snow-->
                      <template v-if="condition.key === 'snow'">
                        <v-text-field
                          filled
                          dense
                          :label="alertType[5].text"
                          type="number"
                          :min="0"
                          :max="5"
                          v-model="condition.number"
                        ></v-text-field>
                      </template>

                      <!-- Storm-->
                      <template v-if="condition.key === 'storm'">
                        <v-text-field
                          filled
                          dense
                          :label="alertType[6].text"
                          type="number"
                          :min="0"
                          :max="5"
                          v-model="condition.number"
                        ></v-text-field>
                      </template>

                      <!-- Ice-->
                      <template v-if="condition.key === 'ice'">
                        <v-text-field
                          filled
                          dense
                          :label="alertType[7].text"
                          type="number"
                          :min="0"
                          :max="5"
                          v-model="condition.number"
                        ></v-text-field>
                      </template>

                      <!-- Rain real time-->
                      <template v-if="condition.key === 'rain-now'">
                        <v-checkbox
                          disabled
                          :label="alertType[8].text"
                          v-model="condition.bool"
                        />
                      </template>
                    </v-col>

                    <v-col cols="1">
                      <!-- Delete cta -->
                      <v-btn
                        x-small
                        fab
                        :loading="loading"
                        color="error"
                        @click="removeAlert(condition.id)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>

              <v-col class="text-right pa-0 ma-0">
                <v-btn
                  v-if="edit"
                  small
                  :loading="loading"
                  elevation="0"
                  color="error mr-2"
                  @click="deleteAlert"
                  >{{ $t("alerts.deleteBtn") }}</v-btn
                >
                <v-btn
                  small
                  elevation="0"
                  color="success"
                  :loading="loading"
                  @click="edit ? updateAlert() : createAlert()"
                  >{{
                    edit ? $t("alerts.updateBtn") : $t("alerts.saveBtn")
                  }}</v-btn
                >
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card elevation="0" color="grey lighten-5">
            <v-card-text>
              <v-list-group :value="$vuetify.breakpoint.mobile ? false : true">
                <template v-slot:activator>
                  <v-list-item-title
                    ><h3>{{ $t("alerts.lastAlerts") }}</h3></v-list-item-title
                  >
                </template>
                <v-simple-table height="50vh" fixed-header>
                  <tbody>
                    <tr v-for="(alert, i) in alertsList" :key="i">
                      <td>
                        <span>{{
                          moment(alert.date).format(
                            "dddd Do MMMM YYYY [à] H[h]mm"
                          )
                        }}</span
                        ><br />
                        <span v-html="alert.texte_complet"></span>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-list-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>

    <v-col fixed>
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-left">Alertes</th>
            <th class="text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="alert in alerts" :key="alert.id">
            <td class="text-left">{{ alert.name }}</td>
            <td class="text-right">
              <v-btn
                small
                elevation="0"
                color="success"
                @click="setAlert(alert)"
                :loading="loading"
                class="mr-5"
                >{{ $t("alerts.updateBtn") }}</v-btn
              >
              <v-btn
                small
                elevation="0"
                color="error mr-2"
                @click="deleteAlert(alert.id)"
                :loading="loading"
                >{{ $t("alerts.deleteBtn") }}</v-btn
              >
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <l-map
        class="map"
        ref="map"
        v-if="showMap"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
      >
        <l-marker
          v-if="markerLatLon.length > 0"
          :lat-lng="markerLatLon"
        ></l-marker>

        <LMarker
          v-for="(alert, i) in alerts"
          :key="i"
          :lat-lng="[alert.lat, alert.lon]"
          @click="setAlert(alert)"
        >
          <LIcon :iconAnchor="[15, 15]">
            <v-btn color="grey darken-3" fab x-small
              ><v-icon small color="white">mdi-alert</v-icon></v-btn
            >
          </LIcon>
        </LMarker>
        <l-tile-layer :url="url" />
        <l-control position="topright"> </l-control>
        <l-control position="topright">
          <v-alert v-if="cityName" class="rounded-0" type="success">
            <h3>
              {{ $t("alerts.citySelected") }} <b>{{ cityName }}</b>
            </h3>
          </v-alert>
        </l-control>
      </l-map>
      <v-snackbar v-model="success" color="success" top>{{
        $t("alerts.snackbarSuccess")
      }}</v-snackbar>
      <v-snackbar v-model="error" color="error" top>{{
        $t("alerts.snackbarError")
      }}</v-snackbar>
    </v-col>
  </v-row>
</template>

<script>
/* eslint-disable */

// Vue Leaflet
import { LMap, LTileLayer, LControl, LMarker, LIcon } from "vue2-leaflet";
import { mapState } from "vuex";
import api from "../../api";

import moment from "moment";

moment.locale("fr");

export default {
  name: "Alertes",

  components: {
    LMap,
    LTileLayer,
    LControl,
    LMarker,
    LIcon,
  },
  computed: {
    ...mapState(["user"]),
    alertTypeFiltered() {
      let filtered = this.alertType.filter(
        (map) => !this.conditions.find((elem) => elem.key == map.value)
      );

      return filtered;
    },
    alertType() {
      return [
        { text: this.$t("alerts.alertType.title"), value: "start" },
        { text: this.$t("alerts.alertType.wind"), value: "wind", hint: "km/h" },
        {
          text: this.$t("alerts.alertType.temp-min"),
          value: "temp-min",
          hint: "°C",
        },
        {
          text: this.$t("alerts.alertType.temp-max"),
          value: "temp-max",
          hint: "°C",
        },
        {
          text: this.$t("alerts.alertType.rain-max"),
          value: "rain-max",
          hint: "mm",
        },
        { text: this.$t("alerts.alertType.snow"), value: "snow" },
        { text: this.$t("alerts.alertType.storm"), value: "storm" },
        { text: this.$t("alerts.alertType.ice"), value: "ice" },
        { text: this.$t("alerts.alertType.rain-now"), value: "rain-now" },
      ];
    },
    fields() {
      if (!this.model) return [];

      return Object.keys(this.model).map((key) => {
        return {
          key,
          value: this.model[key] || "n/a",
        };
      });
    },
    items() {
      return this.entries.map((chunk) =>
        chunk.cp
          ? { ...chunk, search_nom: `${chunk.nom} (${chunk.cp.slice(0, 2)}) ${chunk.iso}` }
          : { ...chunk, search_nom: `${chunk.nom} ${chunk.iso}` }
      );
    },
  },
  data() {
    return {
      success: false,
      error: false,
      edit: null,
      alerts: [],
      alertsList: [],
      conditions: [],
      geoname: null,
      inputClass: ["searchInput"],
      markerLatLon: [],
      cityName: null,
      inputText: "",
      showMap: true,
      zoom: 5,
      choice: "start",
      center: [47, 2],
      entries: [],
      model: null,
      search: null,
      loading: false,
      isLoading: false,
      mapOptions: {
        zoomSnap: 0.5,
      },
      url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
    };
  },

  methods: {
    moment,
    goTo() {
      this.$router.push(`/forecasts/${this.model.geoname}/${this.model.nom}`);
    },
    addAlerte(e) {
      if (this.choice !== "start") {
        var config = {
          id: null,
          key: null,
          number: null,
          bool: null,
        };

        config.key = this.choice;

        if (
          config.key == "snow" ||
          config.key == "storm" ||
          config.key == "ice" ||
          config.key == "rain-now"
        )
          config.bool = true;

        config.id = this.conditions.length + 1;

        this.conditions.push(config);
      }
    },
    removeAlert(index) {
      this.conditions = this.conditions.filter(
        (condition) => condition.id !== index
      );
    },
    setAlert(alert) {
      this.edit = alert.id;
      this.cityName = alert.name;
      this.markerLatLon = [alert.lat, alert.lon];
      this.conditions = alert.config;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    displayItems: (e) => {
      return e.nom;
    },
    selectCountry(e) {
      this.conditions = [];

      let LatLon = [parseFloat(e.lat), parseFloat(e.lon)];

      this.cityName = e.nom;

      this.geoname = e.geoname;

      this.markerLatLon = LatLon;

      this.$refs.map.mapObject.setView(LatLon, 12);
    },
    async getAlerts() {
      let res = await api.alert.get(this.user.id_user);

      this.alertsList = res;
    },
    async getMapAlerts() {
      let res = await api.alert.getMapAlerts(this.user.id_user);

      this.alerts = res;
    },
    async createAlert() {
      this.loading = true;
      try {
        await api.alert.createAlert(
          this.user.id_user,
          this.geoname,
          this.conditions
        );
        if (!this.user.favoris.find((map) => map.id_ville == this.geoname)) {
          await api.users.subsfavorite(this.user.id_user, {
            id_ville: this.geoname,
            name: this.cityName,
          });
          let user = await api.users.get(this.user.id_user);
          this.$store.dispatch("setUser", user);
        }

        this.success = true;

        await this.getMapAlerts();
        this.$nextTick(() => {
          let selectedAlert = this.alerts.find(
            (map) => map.geoname == this.geoname
          );
          this.setAlert(selectedAlert);
        });
      } catch (err) {
        this.error = true;
      }
      this.loading = false;
    },
    async updateAlert() {
      try {
        await api.alert.updateAlert(
          this.user.id_user,
          this.edit,
          this.conditions
        );

        this.success = true;

        this.getMapAlerts();
      } catch (err) {
        this.error = true;
      }
    },
    async deleteAlert(alert = this.edit) {
      this.loading = true;
      try {
        await api.alert.deleteAlert(this.user.id_user, alert);

        this.success = true;
        this.model = null;
        this.conditions = [];
        this.markerLatLon = [];
        this.choice = "start";
        this.edit = null;
        this.cityName = null;

        this.getMapAlerts();
      } catch (err) {
        this.error = true;
      }
      this.loading = false;
    },
  },
  watch: {
    search(val) {
      this.isLoading = true;

      // Lazily load input items
      api.cities
        .search(val)
        .then((res) => {
          this.entries = res;
          this.count = res.length;
        })
        .catch((err) => {
          console.err(err.message);
        })
        .finally(() => (this.isLoading = false));
    },
  },
  async mounted() {
    await this.getAlerts();
    await this.getMapAlerts();
    if (this.$route.query.geoname) {
      let alert = this.alerts.find(
        (map) => map.geoname == this.$route.query.geoname
      );
      if (alert) {
        this.setAlert(alert);
      } else {
        let countries = await api.cities.search(this.$route.query.cityName);
        let country = countries.find(
          (map) => map.geoname == this.$route.query.geoname
        );
        if (country) {
          this.selectCountry(country);
        }
      }
    }
  },
};
</script>

<style>
* {
  word-break: break-word;
}

.leaflet-control {
  width: 100%;
  margin: 0px !important;
}

.leaflet-top.leaflet-right {
  width: 100%;
  margin: 0px !important;
}

.map {
  height: 70vh;
  min-height: 500px;
  margin-top: 20px;
  z-index: 1;
}
</style>
